import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { FooterWidgetStyled } from "./styled";
import { SocialMediaAccountWidget } from "widgets";
import { Icons } from "components";

const FooterWidget = () => {
  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 300);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleScrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <FooterWidgetStyled>
      {/* <div className="footer_layout">
        <div className="footer_container">
          <div className="footer_column1">
            <img
              className="logo"
              src="/assets/images/logos/logo-make-waves.png"
              alt="logo"
            />
            <div className="text_column1">© Yamaha Corporation.</div>
          </div>
          <div className="footer_column234">
            <div className="column234_text">
              {t("Products & Services", { ns: "common" })}
            </div>
            <div
              className="column234_text"
              onClick={() =>
                navigate(`${ROUTE_PATH.PRODUCT_WARRANTEE}/register`)
              }
            >
              {t("Product Warranty", { ns: "common" })}
            </div>
            <div
              className="column234_text"
              onClick={() => navigate(`${ROUTE_PATH.BOOKING}`)}
            >
              {t("Flagship Store, Bangkok", { ns: "common" })}
            </div>
            <div
              className="column234_text"
              onClick={() =>
                navigate(
                  `${ROUTE_PATH.MUSIC_HALL_AND_PRACTICE}/6913fddf8682dc3a88f16b7c`,
                )
              }
            >
              {t("Music Hall, Bangkok", { ns: "common" })}
            </div>
            <div
              className="column234_text"
              onClick={() => navigate(ROUTE_PATH.MUSIC_PRACTICE_ROOM)}
            >
              {t("Practice Room", { ns: "common" })}
            </div>
            <div
              className="column234_text"
              onClick={() => navigate(ROUTE_PATH.SPECIAL_POINTS)}
            >
              {t("Special Gift", { ns: "common" })}
            </div>
          </div>
          <div className="footer_column234">
            <div
              className="column234_text"
              onClick={() => navigate(ROUTE_PATH.PRIVILEGE)}
            >
              {t("Privilege", { ns: "common" })}
            </div>
            <div className="column234_text">
              {t("Philosophy & Vision", { ns: "common" })}
            </div>
            <div className="column234_text">
              {t("About Us", { ns: "common" })}
            </div>
            <div className="column234_text">
              {t("Support", { ns: "common" })}
            </div>
          </div>
          <div className="footer_column234">
            <div className="column234_text">
              {t("Terms of Use", { ns: "common" })}
            </div>
            <Link
              className="column234_text"
              to={
                i18n.language === "en"
                  ? "https://th.yamaha.com/en/privacy-policy/index.html"
                  : "https://th.yamaha.com/th/privacy-policy/index.html"
              }
              target="_blank"
              // onClick={() => navigate(ROUTE_PATH.PDPA)}
            >
              {t("Privacy Policy", { ns: "common" })}
            </Link>
            <div className="column234_text">
              {t("Accessibility", { ns: "common" })}
            </div>
            <div className="column234_text">
              {t("Contact Us", { ns: "common" })}
            </div>
          </div>
        </div>
     
      </div> */}
      <div className="footer_logo_layout">
        <img
          className="footer_logo"
          src="/assets/images/logos/logo-white.png"
          alt="logo"
        />
      </div>
      <SocialMediaAccountWidget />
      <div className="footer_copyright">
        <div className="ftc_left_col">
          <Link
            to={"https://th.yamaha.com/en/privacy-policy/index.html"}
            target="_blank"
          >
            Privacy Policy
          </Link>
          <Link
            to={"https://th.yamaha.com/th/privacy-policy/index.html"}
            target="_blank"
          >
            นโยบายส่วนบุคคล
          </Link>
        </div>
        <div className="ftc_right_col">Siam Music Yamaha Co., Ltd.</div>
      </div>

      {showScrollTop && (
        <div className="ArrowDownCircle_button" onClick={handleScrollToTop}>
          <Icons.ArrowDownCircle />
        </div>
      )}
    </FooterWidgetStyled>
  );
};

export default FooterWidget;
